import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/system'
import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  settingsLeftWrapper: {
    [theme.breakpoints.down('tablet')]: {
      display: 'flex',
      alignItems: 'center',
      gap: SPACES.xxl,
    },
  },
  settingsIconWrapper: {
    [theme.breakpoints.down('tablet')]: {
      width: 40,
      height: 40,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: `0px 2px 10px ${theme.palette.custom.grey}`,
      borderRadius: 10,
    },
  },
  settingsIconWrapperLight: {
    backgroundColor: theme.palette.custom.primary,
  },
  lightIcon: {
    '&&': {
      color: theme.palette.custom.white,
      fill: theme.palette.custom.white,
    },
  },
  greyIcon: {
    '&&': {
      color: theme.palette.custom.grey2,
      fill: theme.palette.custom.grey2,
    },
  },
  settingsTitle: {
    [theme.breakpoints.down('tablet')]: {
      margin: 0,
      fontSize: FONTS.SIZES.xl,
      lineHeight: 1.4,

      color: theme.palette.custom.darkBlue2,
    },
  },
  settingsTitleDark: {
    [theme.breakpoints.down('tablet')]: {
      color: theme.palette.custom.darkBlue2,
    },
  },
  settingsItemWrapper: {
    width: '100%',

    [theme.breakpoints.down('tablet')]: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    [theme.breakpoints.up('tablet')]: {
      padding: '40px',
    },
  },

  dropdownWrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  dropdownLeftWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: SPACES.xs,
  },
  dropdownText: {
    margin: 0,

    fontSize: FONTS.SIZES.m,
    lineHeight: 1.34,

    color: theme.palette.custom.darkBlue2,
  },
  dropdownIconWrapper: {
    '&&': {},
  },
  dropdownIcon: {
    width: 10,
    height: 16,
  },
}))

export { useStyles }
